
export const pizza = [
  {
    id: 1,
    name: "SUPREMA",
    price: 7500,
    description: "Salsa pomodoro, queso mozarella, jamón, tocineta, lomito, cebolla caramelizada, hongos y chile dulce.",
    imageUrl: "/images/pizzatypes/suprema.jpeg",
  },
  {
    id: 2,
    name: "CALZONE BLANCO",
    price: 6500,
    description: "Queso mozarella, jamón, hongos, pollo, arugula y tomate cherry.",
    imageUrl: "/images/pizzhorno.jpg",
  },
  {
    id: 3,
    name: "LA DE LA CASA",
    price: 7500,
    description: "Salsa pomodoro, queso mozarella, tocineta, cebolla caramelizada, chorizo y jalapeños.",
    imageUrl: "/images/pizzaspromo_4.jpeg",
  },
  {
    id: 4,
    name: "LA LOMITO",
    price: 7500,
    description: "Salsa pomodoro, queso mozarella, lomito, cebolla caramelizada y hongos.",
    imageUrl: "/images/pizzaspromo_1.jpeg",
  },
  {
    id: 5,
    name: "LA PESTO",
    price: 7500,
    description: "Pesto, queso mozarella, pollo al grill, tocineta, tomate cherry y cebolla caramelizada.",
    imageUrl: "/images/pizzatypes/pesto.jpeg",
  },
  {
    id: 6,
    name: "LA CHEF",
    price: 8000,
    description: "Salsa pomodoro, queso mozarella, tomate cherry, arugula y queso burrata.",
    imageUrl: "/images/pizzatypes/chef.jpeg",
  },
  {
    id: 7,
    name: "LAS TRADICIONALES",
    price: 6500,
    description: "Pizza jamón, Pizza Peperoni, Pizza hawaiana.",
    imageUrl: "/images/pizzasvarias.jpg",
  },
  {
    id: 8,
    name: "LA DULCE",
    price: 6000,
    description: "Nutella, fresas, banano, almendras.",
    imageUrl: "/images/PizzaDulce.jpeg",
  },
];
